<app-menu>
  <div class="desktop">
    <div class="header">
      <app-titulo text="Pessoas"></app-titulo>
      <div class="header-buttons">
        <app-botao
          width="100%"
          text="Cadastrar pessoa"
          icon="assets/images/add.svg"
          (click)="navigateCadastrarPessoa()"
          *ngIf="permission === 1"
        ></app-botao>
        <app-botao
          type="secundario"
          width="100%"
          text="Exportar Excel"
          icon="assets/images/download-icon.svg"
          (click)="exportExcel()"
        ></app-botao>
      </div>
    </div>
    <div class="table-header">
      <h1 class="table-title">Listagem</h1>
      <div class="table-filters">
        <app-input
          label="Nome:"
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          [(ngModel)]="pesquisaParams.TxNome"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-input
          label="CPF:"
          type="search"
          typeSearch="number"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          [(ngModel)]="pesquisaParams.TxCpf"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
      </div>
    </div>
    <app-tabela [data]="tableData" [columns]="tableColumns"></app-tabela>
    <div class="paginacao">
      <app-paginacao
        [pages]="pesquisaParams.MaxPages"
        (selectedPage)="mudarPagina($event)"
      ></app-paginacao>
    </div>
  </div>

  <div class="mobile">
    <app-titulo text="Pessoas"></app-titulo>
    <div class="listagem">
      <div
        class="menu-mobile"
        (click)="this.expandirCardsMobile = !this.expandirCardsMobile"
      >
        <app-titulo class="title" text="Listagem"></app-titulo>
        <img
          *ngIf="!expandirCardsMobile"
          src="assets/images/arrow-down.svg"
          class="expandir-icon"
        />
        <img
          *ngIf="expandirCardsMobile"
          src="assets/images/arrow-up.svg"
          class="expandir-icon"
        />
      </div>
      <div class="mobile-filters">
        <app-input
          label="Nome:"
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          [(ngModel)]="pesquisaParams.TxNome"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-input
          label="CPF:"
          type="search"
          placeholder="Pesquisar"
          icon="assets/images/search.svg"
          *ngIf="expandirCardsMobile"
          [(ngModel)]="pesquisaParams.TxCpf"
          (ngModelChange)="onChangeSearch()"
        ></app-input>
        <app-botao
          width="100%"
          text="Cadastrar pessoa"
          icon="assets/images/add.svg"
          (click)="navigateCadastrarPessoa()"
          *ngIf="permission === 1"
        ></app-botao>
      </div>
      <app-card-mobile
        [data]="tableData"
        [rows]="rowsMobile"
        [expand]="expandirCardsMobile"
      ></app-card-mobile>
      <app-paginacao
        [pages]="pesquisaParams.MaxPages"
        (selectedPage)="mudarPagina($event)"
      ></app-paginacao>
      <app-botao
        type="secundario"
        text="Exportar Excel"
        width="100%"
        icon="assets/images/download-icon.svg"
      ></app-botao>
    </div>
  </div>
</app-menu>

<app-loader *ngIf="loader" />
